import { isEmpty, trimEnd } from 'lodash';
import * as storage from '@inqool/uas-web-core/es/utils/storage';
import errorMessages from './errorMessages';

export const serialize = (obj = {}) =>
  Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');

export const json = async (fn: any, ...args: any[]): Promise<any> => {
  const response = await fn(...args);

  return await response.json();
};

const bearerResponse = async (response: Promise<any>) => {
  const result = await response;

  if (result.status === 401) {
    await fetch('/metropolis/api/hr/employees/log-out', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    storage.remove('token');
    storage.remove('gistoken');
    storage.remove('user');
    storage.remove('id');
    storage.remove('permissions');
    storage.remove('extensions');
    throw new Error('Byli jste automaticky odhlášeni');
  }

  if (result.ok && !isEmpty(result.headers.get('bearer'))) {
    storage.put('token', result.headers.get('bearer'));
  }

  if (!result.ok) {
    let errorJson;
    try {
      errorJson = await result.json();
    } catch (e) {
      throw new Error(errorMessages());
    }
    throw new Error(errorMessages(errorJson));
  }

  return result;
};

export const defaultOptions: RequestInit = {
  credentials: 'same-origin',
  headers: new Headers()
};

const USER_AGENT_DEVICE = 'User-Agent-Device';
const WEB = 'web';

storage.put('uas-fetch-headers', JSON.stringify({ [USER_AGENT_DEVICE]: WEB }));

export default (url, { params, context, checkToken, ...rest }: any = {}) => {
  const token = storage.get('token');
  const options = { ...defaultOptions, ...rest };
  const headers = options.headers || new Headers();
  const checker = checkToken instanceof Function ? checkToken : () => true;
  if (token && token !== 'null' && checker(token)) {
    headers.set('Authorization', `Bearer ${token}`);
    headers.set('Authorizationjwt', `Bearer ${token}`);
    headers.set(USER_AGENT_DEVICE, WEB);
  }
  const queryString = serialize(params);
  const questionMark = isEmpty(queryString) ? '' : '?';
  return bearerResponse(fetch(`${trimEnd(context, '/')}${url}${questionMark}${queryString}`, { ...options, headers }));
};



// WEBPACK FOOTER //
// ./src/utils/fetch.ts